import { hasFeatureFlag, FEATURES } from '@cinch/oxd-utils/feature-flags/src'
import '@cinch/oxd-utils/analytics/src/types'

export const identify = (userId: string, data?: any) => {
  if (!hasFeatureFlag(FEATURES.IDENTIFY_USERS)) return
  window.analytics.identify(userId, { ...data })
}

export const track = (eventName: string, data?: any) => {
  if (eventName.length === 0) return
  window.analytics.track(eventName, { ...data })
}

export const reset = () => {
  window.analytics.reset()
}
